import React, {useState} from 'react';
import {StandardDatePicker} from './StandardDatePicker';
import {ContentWrapper} from './RangeDatePicker.style';
import {getEffectiveDate} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface RangeDatePickerProps {
    readonly dateFrom?: Date;
    readonly labelFrom: string;
    readonly initializeFrom: boolean;
    readonly isClearableFrom: boolean;
    readonly isNullableFrom: boolean;
    readonly dateTo?: Date;
    readonly labelTo: string;
    readonly initializeTo: boolean;
    readonly isClearableTo: boolean;
    readonly  isNullableTo: boolean;
    onChange: (dateValidFrom?: Date, dateValidTo?: Date) => void;
}

export const RangeDatePicker: React.VFC<RangeDatePickerProps> = (props) => {
    const [dateValidFrom, setDateValidFrom] = useState<Date | undefined>(props.dateFrom);
    const [dateValidTo, setDateValidTo] = useState<Date | undefined>(props.dateTo);

    const onChangeDateFromHandler = (date?: Date) => {
        setDateValidFrom(date);
        props.onChange(date, dateValidTo);
    };

    const onChangeDateToHandler = (date?: Date) => {
        setDateValidTo(date);
        props.onChange(dateValidFrom, date);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            <StandardDatePicker date={dateValidFrom}
                                label={props.labelFrom}
                                initialize={props.initializeFrom}
                                isClearable={props.isClearableFrom}
                                isNullable={props.isNullableFrom}
                                minDate={getEffectiveDate()}
                                maxDate={dateValidTo}
                                onChange={onChangeDateFromHandler}/>
            <StandardDatePicker date={dateValidTo}
                                label={props.labelTo}
                                initialize={props.initializeTo}
                                isClearable={props.isClearableTo}
                                isNullable={props.isNullableTo}
                                minDate={dateValidFrom}
                                maxDate={undefined}
                                onChange={onChangeDateToHandler}/>
        </ContentWrapper>
    );
};
